export const EXPERIMENT_FLAG = "show-reverse-trial-opd";
export const GET_DIALOG_MESSAGE_TYPE = "reverse-trial.get-dialog";
export const STEP_PREF_KEY = "reverse_trial_step";
export const TRIAL_START_DATE_PREF_KEY = "reverse_trial_start_date";
export const DIALOG_ACTION_MESSAGE_TYPE = "reverse-trial.dialog-action";
export const DISMISS_DIALOG_MESSAGE_TYPE = "reverse-trial.dismiss-dialog";
export const TRIAL_DURATION_DAYS = 14;
export const MIDPOINT_THRESHOLD_DAYS = 7;
export const MS_PER_DAY = 1000 * 60 * 60 * 24;
